import { useContext, useRef } from 'react';
import { Button } from '../../../../../common/view/button/button/button';
import { Color } from '../../../../../common/view/color/color';
import { EffectContext } from '../../../../../common/view/effect/effect.context';
import { Icon } from '../../../../../common/view/icon/icon';
import { MonoIcon } from '../../../../../common/view/icon/mono/mono-icon';
import { Menu } from '../../../../../common/view/menu/menu';
import { MenuItem } from '../../../../../common/view/menu/menu-item';
import { MenuPositions } from '../../../../../common/view/menu/menu-positions';
import { ImmerFuncs } from '../../../../../external/immer/immer.funcs';
import { ServerApi } from '../../../../../external/server/server.api';
import { RectFuncs } from '../../../../../foundation/geometry/rect.funcs';
import { ArrayFuncs } from '../../../../../foundation/js/array.funcs';
import { TripleX } from '../../../../../foundation/layout/triple-x';
import { EffectWire } from '../../../../core/effect/effect.wire';
import { EffectWireFuncs } from '../../../../core/effect/effect.wire.func';
import { SnoozeEffectDataWire } from '../../../../core/effect/effects/snooze/snooze-effect-data.wire';
import { NodeStore } from '../../../../core/node/node.store';
import { EffectNodeItemStyle } from '../../effect-node-item.style';

export function SnoozeEffectNodeItem({ nodeId, effect }: { nodeId: string; effect: EffectWire<SnoozeEffectDataWire> }) {
  const node = NodeStore.useItem(nodeId);
  const moreButtonRef = useRef<HTMLDivElement>(null);
  const { popupApi } = useContext(EffectContext);

  const text = (() => {
    return `Snooze until: ${effect.data.date}`;
  })();

  const handleRemove = () => {
    popupApi.pop();
    const effects = ArrayFuncs.ensure(node.effects);
    const newEffects = ImmerFuncs.produce(effects, (draft) => {
      EffectWireFuncs.removeEffect({ effects: draft, effect });
    });

    NodeStore.updateItem(nodeId, { effects: newEffects });
    ServerApi.updateNode(nodeId, { effects: newEffects });
  };

  return (
    <EffectNodeItemStyle.Container>
      <TripleX.Container $align="center" $gap="4px">
        <TripleX.Side>
          <EffectNodeItemStyle.IconContainer>
            <Icon icon={MonoIcon.snooze} size="16px" />
          </EffectNodeItemStyle.IconContainer>
        </TripleX.Side>
        <TripleX.Rest>
          <EffectNodeItemStyle.Text>{text}</EffectNodeItemStyle.Text>
        </TripleX.Rest>
        <TripleX.Side>
          <EffectNodeItemStyle.ActionButton>
            <Button
              theRef={moreButtonRef}
              icon={MonoIcon.more}
              color={Color.white7}
              size={14}
              onClick={() => {
                const triggerRect = RectFuncs.from(moreButtonRef.current?.getBoundingClientRect() ?? {});
                popupApi.push({
                  component: (
                    <Menu>
                      <MenuItem text={'Remove'} danger={true} onClick={handleRemove} />
                    </Menu>
                  ),
                  triggerRect,
                  positions: MenuPositions,
                });
              }}
            />
          </EffectNodeItemStyle.ActionButton>
        </TripleX.Side>
      </TripleX.Container>
    </EffectNodeItemStyle.Container>
  );
}
